import { Box, Flex, Image, Picture, Typography } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { Section } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"

import { DetailTitle, DetailBody, InfoSectionTitle } from "../components"

const Video = styled.video`
  width: 344px;
  ${(props) => props.theme.mediaQueries.desktop`
    width: 626px;
    margin: 0 auto;
  `}
`

const Text = styled(Typography).attrs((props) => ({
  fontSize: 16,
  fontWeight: props.subtitle ? 700 : 300,
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  mb: 2,
  ...props,
}))``

const Packaging = () => (
  <Box>
    {/* Temporary hid until new packaging image assets are ready */}
    {/* <Section mb={0}>
      <Box contain>
        <Text
          mx="auto"
          style={{ textAlign: "center" }}
          width={{ _: "auto", desktop: "711px" }}
        >
          Every order is delivered in our custom packaging and includes your
          packing slip and Certificate of Authenticity. We also offer{" "}
          {jewlr_t("terms.personalized")} add-ons for the ultimate gifting
          experience.
        </Text>
        <Box mb={6} mx="auto" textAlign="center">
          <Picture
            alt="Packaging"
            srcSet={[
              {
                height: "245",
                media: "(max-width: 1023px)",
                sizes: "100vw",
                srcSet: `
                  ${require("images/info/packaging/m-jewelry-packaging.jpg")} 344w,
                  ${require("images/info/packaging/m-jewelry-packaging-2x.jpg")} 688w,
                `,
                width: "344",
              },
              {
                height: "596",
                media: "(min-width: 1024px)",
                sizes: "848px",
                srcSet: `
                  ${require("images/info/packaging/jewelry-packaging.jpg")} 848w,
                  ${require("images/info/packaging/jewelry-packaging-2x.jpg")} 1696w,
                `,
                width: "848",
              },
            ]}
            width={{ _: "100%", desktop: "848px" }}
          />
        </Box>
      </Box>
    </Section>

    <Box contain mb={56}>
      <Section
        as={Flex}
        display={{ _: "block", tablet: "flex" }}
        gutter={{ tablet: 4 }}
        hasBg
        px={2}
        py={{ _: 3, tablet: 6 }}
      >
        <Box
          borderRight={{ tablet: "1px solid #DDD" }}
          flex="1"
          mb={{ _: 4, tablet: 0 }}
        >
          <DetailTitle subtitle>1. {jewlr_t("terms.Jewelry")} Box</DetailTitle>
          <DetailBody>
            Your {jewlr_t("terms.personalized")} items will be shipped to you in
            our deluxe black velvet pouch or signature black{" "}
            {jewlr_t("terms.jewelry")} box.
          </DetailBody>
          <DetailTitle subtitle>2. {jewlr_t("terms.Shipping")} Box</DetailTitle>
          <DetailBody>
            Our custom unique matte laminate outer box is designed to protect
            your {jewlr_t("terms.jewelry")} and serve as a luxurious gift box.
          </DetailBody>
        </Box>

        <Box flex="1">
          <DetailTitle subtitle>3. Certificate of Authenticity</DetailTitle>
          <DetailBody>
            The Certificate of Authenticity guarantees that your custom item is
            authentic and crafted to exceed all quality standards.
          </DetailBody>
          <DetailTitle subtitle>4. Packing Slip</DetailTitle>
          <DetailBody>
            The packing slip includes the details of your purchase, including
            the date, order number, metals, stones, and engravings
          </DetailBody>
        </Box>
      </Section>
    </Box>

    <Section>
      <Box contain>
        <InfoSectionTitle>
          {jewlr_t("terms.Jewelry")} Packaging
        </InfoSectionTitle>
        <Text>
          Our {jewlr_t("terms.jewelry")} arrives elegantly packaged in premium
          black boxes or deluxe velvet pouches, depending on the item. We also
          offer the option to upgrade your packaging for a{" "}
          {jewlr_t("terms.personalized")} gifting experience.*
        </Text>
        <Box mb={4} mt={3} textAlign="center">
          <Picture
            alt={`${jewlr_t("terms.Jewelry")} Packaging`}
            srcSet={[
              {
                height: "190",
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
                  ${require("images/info/packaging/m-necklace-packaging.jpg")} 344w,
                  ${require("images/info/packaging/m-necklace-packaging-2x.jpg")} 688w
                `,
                width: "344",
              },
              {
                height: "467",
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
                  ${require("images/info/packaging/necklace-packaging.jpg")} 716w,
                  ${require("images/info/packaging/necklace-packaging-2x.jpg")} 1430w
                `,
                width: "716",
              },
            ]}
            width={{ _: "100%", desktop: "715px" }}
          />
        </Box>
      </Box>
    </Section> */}

    <Section>
      <Box contain>
        <InfoSectionTitle>Gift Wrapping</InfoSectionTitle>
        <Text>
          Upgrade your {jewlr_t("terms.personalized")} gift with our custom gift
          wrap! Available for {jewlr_t("terms.jewelry")} items, choose from
          beautiful gift wrap options, complete with a white ribbon for the
          perfect finishing touch.
        </Text>
        <Box mb={4} mt={3} textAlign="center">
          <Picture
            alt="Gift Wrapping"
            srcSet={[
              {
                height: "215",
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
                  ${require("images/info/packaging/m-gift-wrap.jpg")} 344w,
                  ${require("images/info/packaging/m-gift-wrap-2x.jpg")} 688w
                `,
                width: "344",
              },
              {
                height: "413",
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
                  ${require("images/info/packaging/gift-wrap.jpg")} 1045w,
                  ${require("images/info/packaging/gift-wrap-2x.jpg")} 2090w
                `,
                width: "646",
              },
            ]}
            width={{ _: "100%", desktop: "645px" }}
          />
        </Box>
      </Box>
    </Section>

    <Section>
      <Box contain>
        <InfoSectionTitle>
          {jewlr_t("terms.Personalized")} Greeting Cards
        </InfoSectionTitle>{" "}
        <Text>
          Complete your gift with a {jewlr_t("terms.personalized")} greeting
          card. In {jewlr_t("cart")}, choose one of our designs and a{" "}
          {jewlr_t("terms.customizable")} pre-written message, or write a
          meaningful note of your own. We will print and package your card with
          your gift.
        </Text>
        <Box mb={4} mt={3} textAlign="center">
          <Image
            alt={`${jewlr_t("terms.Personalized")} Greeting Cards`}
            ratio="642 / 388"
            srcSet={`${require("images/info/packaging/personalized-greeting-cards.jpg")} 642w, ${require("images/info/packaging/personalized-greeting-cards-2x.jpg")} 1284w`}
            width={{ _: "100%", desktop: "642px" }}
          />
        </Box>
      </Box>
    </Section>

    <Section>
      <Box contain mb={2}>
        <InfoSectionTitle>
          {jewlr_t("terms.Personalized")} Photo Box
        </InfoSectionTitle>
        <Text>
          Upgrade our elegant black {jewlr_t("terms.jewelry")} box to a{" "}
          {jewlr_t("terms.personalized")} photo box! Upload a favorite photo or
          choose a custom design, and we&apos;ll print the image directly on
          your {jewlr_t("terms.jewelry")} box to create a one-of-a-kind
          keepsake.*
        </Text>
      </Box>
      <Box display="block" textAlign="center">
        <Box display="block">
          <Video
            autoPlay
            className="lazyload"
            data-poster={`${sl.config.jewlr_asset_url}packaging/customize_box_thumb.jpg`}
            loop
            muted
            playsInline
            preload="none"
          >
            <source
              src={`${sl.config.jewlr_asset_url}packaging/customize_box.mp4`}
              type="video/mp4"
            />
          </Video>
        </Box>
      </Box>
      <Box contain mb={{ _: "32px", desktop: "100px" }}>
        <Text
          fontSize={14}
          lineHeight="18px"
          mt={0}
          mx="auto"
          textAlign="center"
          width={{ _: "260px", tablet: "389px" }}
        >
          *Available for select items only. Look for the option to upgrade on
          the product page when you {jewlr_t("terms.personalize")} your item.
        </Text>
      </Box>
    </Section>
  </Box>
)

export default Packaging
